import { Navigate, useParams } from "react-router";

/**
 * Endereço que só existe na versão nova (ex.: /freelancers/:id/editar), aberto na
 * antiga por um link ou por quem trocou de versão: leva para a tela equivalente
 * daqui em vez de cair no "não encontrado". `to` aceita os mesmos :params da rota,
 * também na query.
 */
export function RotaDaVersaoNova({ to }: { to: string }) {
  const params = useParams();
  const destino = to.replace(/:(\w+)/g, (_match, name: string) => encodeURIComponent(params[name] ?? ""));
  return <Navigate to={destino} replace />;
}

/** Rotas da versão nova e onde cada uma cai na antiga. */
export const ROTAS_DA_VERSAO_NOVA: Array<[string, string]> = [
  ["/freelancers/:id/editar", "/freelancers/:id?editar=1"],
  ["/empresas/:id/editar", "/empresas/:id"],
  ["/vagas/nova", "/vagas"],
  ["/vagas/:id/editar", "/vagas/:id"],
  ["/controle-projetos/novo", "/controle-projetos?novo=1"],
  ["/controle-projetos/:id/editar", "/controle-projetos?editar=:id"],
  ["/agencias/nova", "/agencias"],
  ["/agencias/:id/editar", "/agencias/:id"],
  ["/avaliacoes/perfil-freelancer/novo", "/avaliacoes/perfil-freelancer"],
  ["/avaliacoes/formularios/novo", "/avaliacoes/formularios"],
  ["/avaliacoes/formularios/:id/editar", "/avaliacoes/formularios"],
  ["/admin/recomendacao-pesos/nova-versao", "/admin/recomendacao-pesos"],
  ["/relatorios/*", "/dashboard"],
];
